import script from "./CommonButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonButton.vue?vue&type=script&setup=true&lang=ts"

import "./CommonButton.vue?vue&type=style&index=0&id=8b08a88e&lang=sass"

const __exports__ = script;

export default __exports__